/* DSL Studio – teknisk katalog bladre-motor (PDF.js). Selvstændig, scoper pr. sektion. */
(function(){
  function initOne(root){
    if(root.__dslkInit) return; root.__dslkInit = true;
    var cfgEl = root.querySelector('.dslk-cfg');
    if(!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch(e){ return; }
    var parts = (cfg.parts||[]).filter(function(p){ return p.url && p.count>0; });
    if(!parts.length) return;
    var RATIO = cfg.ratio || 1.636;

    var stage  = root.querySelector('.dslk-stage');
    var book   = root.querySelector('.dslk-book');
    var base   = root.querySelector('.dslk-base');
    var loader = root.querySelector('.dslk-loader');
    var bctx   = base.getContext('2d');

    var TOTAL = parts.reduce(function(a,p){ return a+p.count; },0);
    var cum=[], acc=0; parts.forEach(function(p){ cum.push(acc); acc+=p.count; });
    function locate(g){ for(var i=parts.length-1;i>=0;i--){ if(g>cum[i]) return {pi:i, local:g-cum[i]}; } return {pi:0, local:g}; }

    var current = 1, busy = false;
    var scale = 1, panX = 0, panY = 0;
    book.style.aspectRatio = RATIO + ' / 1';

    var docs = [];
    function getDoc(pi){
      if(!docs[pi]){
        docs[pi] = pdfjsLib.getDocument({ url: parts[pi].url, disableAutoFetch: true, disableStream: false, rangeChunkSize: 262144 }).promise;
      }
      return docs[pi];
    }

    var cache = {}, rendering = {};
    function targetWidth(){
      var w = (book.clientWidth || 900) * (window.devicePixelRatio || 1);
      return Math.max(1100, Math.min(2600, Math.floor(w)));
    }
    function renderHi(g, w){
      var loc = locate(g);
      return getDoc(loc.pi).then(function(doc){ return doc.getPage(loc.local); }).then(function(page){
        var vp1 = page.getViewport({ scale: 1 });
        var vp = page.getViewport({ scale: w / vp1.width });
        var c = document.createElement('canvas');
        c.width = Math.ceil(vp.width); c.height = Math.ceil(vp.height);
        return page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise.then(function(){ return c; });
      });
    }
    var hiTimer;
    function scheduleHi(){
      clearTimeout(hiTimer);
      hiTimer = setTimeout(function(){
        if(scale <= 1.25){ if(cache[current]) draw(cache[current]); applyTransform(); return; }
        var w = Math.min(5000, Math.max(1400, Math.floor(book.clientWidth * scale * (window.devicePixelRatio || 1))));
        renderHi(current, w).then(function(c){ draw(c); applyTransform(); }).catch(function(){});
      }, 200);
    }
    function renderPage(g){
      if(g<1 || g>TOTAL) return Promise.reject('oob');
      if(cache[g]) return Promise.resolve(cache[g]);
      if(rendering[g]) return rendering[g];
      var loc = locate(g);
      var pr = getDoc(loc.pi).then(function(doc){ return doc.getPage(loc.local); }).then(function(page){
        var vp1 = page.getViewport({ scale: 1 });
        var s = targetWidth() / vp1.width;
        var vp = page.getViewport({ scale: s });
        var c = document.createElement('canvas');
        c.width = Math.ceil(vp.width); c.height = Math.ceil(vp.height);
        var ctx = c.getContext('2d');
        return page.render({ canvasContext: ctx, viewport: vp }).promise.then(function(){
          cache[g] = c; delete rendering[g]; trim(g); return c;
        });
      });
      rendering[g] = pr;
      return pr;
    }
    function trim(g){ Object.keys(cache).forEach(function(k){ if(Math.abs(parseInt(k,10)-g) > 4){ delete cache[k]; } }); }
    function draw(canvas){
      base.width = canvas.width; base.height = canvas.height;
      bctx.clearRect(0,0,base.width,base.height);
      bctx.drawImage(canvas,0,0);
    }
    function setLoader(on){ loader.style.display = on ? 'flex' : 'none'; }

    function q(sel){ return root.querySelector(sel); }
    function updateUI(){
      q('.dslk-cur').textContent = current;
      var sl = q('.dslk-slider'); sl.value = current;
      q('.dslk-prev').disabled = (current<=1);
      q('.dslk-b-prev').disabled = (current<=1);
      q('.dslk-next').disabled = (current>=TOTAL);
      q('.dslk-b-next').disabled = (current>=TOTAL);
    }
    function preload(g){ [g-1,g+1,g+2].forEach(function(n){ if(n>=1&&n<=TOTAL&&!cache[n]&&!rendering[n]) renderPage(n).catch(function(){}); }); }

    function prefersReduced(){ try{ return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }catch(e){ return false; } }
    function snapshotCanvas(){
      var c = document.createElement('canvas'); c.width=base.width; c.height=base.height;
      c.getContext('2d').drawImage(base,0,0); return c;
    }

    function show(g, dir){
      g = Math.max(1, Math.min(TOTAL, g));
      if(g===current && cache[g]) return;
      setLoader(true); resetZoom();
      renderPage(g).then(function(c){
        setLoader(false);
        if(dir && Math.abs(g-current)===1 && !prefersReduced()){ animateTurn(c, dir, g); }
        else { draw(c); current=g; updateUI(); preload(g); }
      }).catch(function(){ setLoader(false); });
    }

    function animateTurn(destCanvas, dir, g){
      busy = true;
      var leaf = document.createElement('div');
      leaf.className = 'dslk-leaf dslk-leaf-'+dir;
      var lc = document.createElement('canvas');
      var shade = document.createElement('div'); shade.className='dslk-leaf-shade';
      if(dir==='next'){
        var out = snapshotCanvas();
        lc.width=out.width; lc.height=out.height; lc.getContext('2d').drawImage(out,0,0);
        draw(destCanvas);
        leaf.appendChild(lc); leaf.appendChild(shade); book.appendChild(leaf);
        leaf.style.transform = 'rotateY(0deg)'; void leaf.offsetWidth;
        leaf.classList.add('dslk-anim');
        leaf.style.transform = 'rotateY(-180deg)'; shade.style.opacity = '0.28';
      } else {
        lc.width=destCanvas.width; lc.height=destCanvas.height; lc.getContext('2d').drawImage(destCanvas,0,0);
        leaf.appendChild(lc); leaf.appendChild(shade); book.appendChild(leaf);
        leaf.style.transform = 'rotateY(-180deg)'; shade.style.opacity = '0.28'; void leaf.offsetWidth;
        leaf.classList.add('dslk-anim');
        leaf.style.transform = 'rotateY(0deg)'; shade.style.opacity = '0';
      }
      var done = false;
      function finish(){
        if(done) return; done = true;
        if(dir==='prev') draw(destCanvas);
        if(leaf.parentNode) leaf.parentNode.removeChild(leaf);
        current = g; busy = false; updateUI(); preload(g);
      }
      leaf.addEventListener('transitionend', finish);
      setTimeout(finish, 950);
    }

    function next(){ if(busy||current>=TOTAL) return; show(current+1,'next'); }
    function prev(){ if(busy||current<=1) return; show(current-1,'prev'); }
    function goto(g){ if(busy) return; g=Math.max(1,Math.min(TOTAL,g)); if(g===current) return; show(g, (g===current+1?'next':(g===current-1?'prev':null))); }

    function applyTransform(){ base.style.transform = 'translate('+panX+'px,'+panY+'px) scale('+scale+')'; base.style.cursor = scale>1 ? 'grab' : 'default'; }
    function resetZoom(){ scale=1; panX=0; panY=0; applyTransform(); }
    function zoomTo(s){ scale = Math.max(1, Math.min(4, s)); if(scale===1){ panX=0; panY=0; } applyTransform(); scheduleHi(); }
    function clampPan(){ var mX=(base.clientWidth*(scale-1))/2, mY=(base.clientHeight*(scale-1))/2; panX=Math.max(-mX,Math.min(mX,panX)); panY=Math.max(-mY,Math.min(mY,panY)); }

    q('.dslk-next').addEventListener('click', next);
    q('.dslk-prev').addEventListener('click', prev);
    q('.dslk-b-next').addEventListener('click', next);
    q('.dslk-b-prev').addEventListener('click', prev);
    q('.dslk-zin').addEventListener('click', function(){ zoomTo(scale+0.6); });
    q('.dslk-zout').addEventListener('click', function(){ zoomTo(scale-0.6); });
    q('.dslk-slider').addEventListener('input', function(e){ q('.dslk-cur').textContent = e.target.value; });
    q('.dslk-slider').addEventListener('change', function(e){ goto(parseInt(e.target.value,10)); });
    q('.dslk-fs').addEventListener('click', function(){ if(document.fullscreenElement){ document.exitFullscreen(); } else if(stage.requestFullscreen){ stage.requestFullscreen(); } });

    document.addEventListener('keydown', function(e){
      var r = stage.getBoundingClientRect();
      if(!(r.top < window.innerHeight && r.bottom > 0)) return;
      if(e.key==='ArrowRight'){ next(); } else if(e.key==='ArrowLeft'){ prev(); }
    });

    book.addEventListener('click', function(e){
      if(scale>1) return;
      var r = book.getBoundingClientRect();
      if((e.clientX - r.left) > r.width*0.5) next(); else prev();
    });
    book.addEventListener('dblclick', function(e){ e.preventDefault(); zoomTo(scale>1?1:2.2); });
    book.addEventListener('wheel', function(e){ if(e.ctrlKey || e.metaKey){ e.preventDefault(); zoomTo(scale + (e.deltaY<0?0.3:-0.3)); } }, {passive:false});

    var dragging=false, sx=0, sy=0;
    book.addEventListener('pointerdown', function(e){ if(scale<=1) return; dragging=true; sx=e.clientX-panX; sy=e.clientY-panY; base.style.cursor='grabbing'; try{ book.setPointerCapture(e.pointerId); }catch(_){} });
    book.addEventListener('pointermove', function(e){ if(!dragging) return; panX=e.clientX-sx; panY=e.clientY-sy; clampPan(); applyTransform(); });
    book.addEventListener('pointerup', function(){ dragging=false; base.style.cursor = scale>1?'grab':'default'; });

    var tsx=0, tsy=0, tActive=false;
    book.addEventListener('touchstart', function(e){ if(scale>1||e.touches.length!==1){ tActive=false; return; } tActive=true; tsx=e.touches[0].clientX; tsy=e.touches[0].clientY; }, {passive:true});
    book.addEventListener('touchend', function(e){ if(!tActive) return; tActive=false; var t=e.changedTouches[0]; var dx=t.clientX-tsx, dy=t.clientY-tsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ if(dx<0) next(); else prev(); } }, {passive:true});

    var rz;
    window.addEventListener('resize', function(){ clearTimeout(rz); rz=setTimeout(function(){ cache={}; renderPage(current).then(draw).catch(function(){}); }, 300); });

    q('.dslk-slider').max = TOTAL;
    q('.dslk-tot').textContent = TOTAL;
    updateUI();
    show(1, null);
    preload(1);
  }

  function boot(){
    if(typeof pdfjsLib === 'undefined'){ setTimeout(boot, 200); return; }
    try { pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js'; } catch(e){}
    document.querySelectorAll('section.dslk').forEach(initOne);
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
